import { config } from "../env";
import {
  Delete,
  DeleteWithPayload,
  get,
  patch,
  post,
  postFileUpload,
  put,
  putFileUpload,
} from "./helpers/http-handler";

export const vendorFileUpload = (payload: object) =>
  postFileUpload(`${config.API_URL}/media-uploads/file/upload`, payload);

export const vendorGetCheckpointLocationDashboardInfo = (
  payload: object
  // ) => get(`${config.API_URL}/vendor-checkpoint/dashboard-info?${queryRequest}`);
) => post(`${config.API_URL}/vendor-checkpoint/dashboard-info`, payload);
export const getDashboardInfo = (
  payload: object
  // ) => get(`${config.API_URL}/vendor-checkpoint/dashboard-info?${queryRequest}`);
) => post(`${config.API_URL}/vendor-checkpoint/dashboard-info`, payload);

export const vendorGetCheckpointLocation = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/by-location?${queryRequest}`);

export const vendorGetCheckpointInfoBySpecificLocation = (
  queryRequest: string
) => get(`${config.API_URL}/vendor-checkpoint?${queryRequest}`);

export const vendorDeleteCheckpointLocationFile = (
  id: string,
  document_id: string
) =>
  Delete(
    `${config.API_URL}/vendor-checkpoint/${id}/document?document_id=${document_id}`
  );

export const submitVendorCheckpointTasks = (payload: object) =>
  patch(`${config.API_URL}/vendor-checkpoint/bulk/submission`, payload);

// commnets

export const vendorGetCheckpointLocationCommnets = (queryRequest: string) =>
  get(`${config.API_URL}/comments?${queryRequest}`);

export const vendorAddCheckpointLocationCommnets = (payload: object) =>
  post(`${config.API_URL}/comments`, payload);

export const vendorGetSpecificCheckpointLocationCommnets = (id: string) =>
  get(`${config.API_URL}/comments?id=${id}`);

export const vendorUpdateCheckpointLocationCommnets = (
  id: string,
  payload: object
) => patch(`${config.API_URL}/comments/${id}`, payload);

export const vendorDeleteCheckpointLocationCommnets = (id: string) =>
  Delete(`${config.API_URL}/comments/${id}`);

// history

export const vendorGetCheckpointLocationHistory = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/history?${queryRequest}`);

export const vendorGetCheckpointLocationHistoryExpiryDate = (
  id: string,
  payload: object
) => patch(`${config.API_URL}/vendor-checkpoint/expiry-date/${id}`, payload);

// upload

export const vendorUploadSubmitCheckpointLocation = (payload: object) =>
  patch(`${config.API_URL}/vendor-checkpoint/bulk/update-document`, payload);

// copy-document

export const vendorCopySubmitCheckpointLocation = (
  id: string,
  payload: object
) => patch(`${config.API_URL}/vendor-checkpoint/copy-document/${id}`, payload);

// Upload

export const VendorCheckpointGeneratedPresignedURL = (payload: object) =>
  post(`${config.API_URL}/media-uploads/generate-presigned-url`, payload);

export const VendorCheckpointCreateS3DirectUpload = (payload: object) =>
  post(`${config.API_URL}/media-uploads/create-s3-direct-upload`, payload);

export const VendorCheckpointGeneratedPresignedURLResponseAPI = (
  url: string,
  payload: object
) => putFileUpload(`${url}`, payload);

export const VendorCheckpointUploadDocument = (payload: object) =>
  patch(`${config.API_URL}/vendor-checkpoint/bulk/upload-document`, payload);

export const vendorCheckpointDocumentlist = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/list/documents?${queryRequest}`);

export const VendorCheckpointAssignDocument = (payload: object) =>
  patch(`${config.API_URL}/vendor-checkpoint/assign/documents`, payload);

export const vendorCheckpointDeleteFiles = (payload: object) =>
  DeleteWithPayload(`${config.API_URL}/vendor-checkpoint/documents`, payload);

export const getVendorFilterLocation = () =>
  get(`${config.API_URL}/vendor-checkpoint/filter/locations`);

export const getVendorFilterLegislation = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/filter/legislations?${queryRequest}`
  );

export const exportAuditComplete = (payload: object) =>
  post(`${config.API_URL}/reports/vendor-audit-score`, payload);

export const vendorCheckpointDetailDashboardInfo = (payload: object) =>
  post(`${config.API_URL}/vendor-checkpoint/dashboard-info/vendor`, payload);
